// styling
import styles from './styles.module.scss';

// components
import Spring from '@components/Spring';

// hooks
import { useThemeProvider } from '@contexts/themeContext';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../network/ApiService';

export default function CreditWidget({ teamID }) {
  const { direction } = useThemeProvider();
  const navigate = useNavigate();

  const [unreadCount, setUnreadCount] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!teamID) return;

    const ac = new AbortController();

    (async () => {
      try {
        setError(null);
        const data = await new ApiService().get(`app/conversation/team/${teamID}`);
        const conversations = Array.isArray(data) ? data : [];

        const count = conversations.reduce((acc, conv) => {
          const msgs = Array.isArray(conv.messages) ? conv.messages : [];
          // If you only want incoming (admin) messages, add && !m.sender_team
          const unread = msgs.filter((m) => m && m.read === false /* && !m.sender_team */).length;
          return acc + unread;
        }, 0);

        setUnreadCount(count);
      } catch (e) {
        if (e?.name !== 'AbortError') setError(e?.message || 'Fehler beim Laden');
      }
    })();

    return () => ac.abort();
  }, [teamID]);

  const title = useMemo(() => {
    if (error) return 'Fehler beim Laden';
    if (unreadCount === null) return 'Lade…';
    if (unreadCount === 0) return 'Keine neuen Nachrichten';
    if (unreadCount === 1) return '1 neue Nachricht';
    return `${unreadCount} Ungelesene Nachrichten`;
  }, [unreadCount, error]);

  return (
    <Spring className={`${styles.wrapper} card h-1`}>
      <div className={`${styles.main} ${styles[direction]}`}>
        <div className="d-flex flex-column g-8">
          <span className="text-12">Posteingang</span>
          <h3 className={styles.main_title}>{title}</h3>
        </div>

        <button
          className="btn btn--sm"
          onClick={() => navigate('/office/inbox')}
          aria-label="Chat öffnen"
        >
          Chat
          {typeof unreadCount === 'number' && unreadCount > 0 && (
            <span
              className="ml-8 inline-flex items-center justify-center rounded-full text-10 px-6 py-2"
              style={{ background: 'var(--accent-500)', color: 'white' }}
            >
            </span>
          )}
        </button>
      </div>
      {/* <LazyImage className={styles.media} ... /> */}
    </Spring>
  );
}
